import styled from "styled-components";

export default styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;

    .log-out-button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      margin-bottom: 5rem;
      margin-top: 2rem;
    }
  }
`;
